import { FLAGS, useFlag } from '@iheartjane/feature-flags';

import type { RootLoaderType } from '@jane/kiosk/data-access';
import { useTypedRouteLoaderData } from '@jane/kiosk/hooks/lib/useTypedRouteLoaderData';
import { useGetStore } from '@jane/shared/data-access';
import type { Store } from '@jane/shared/types';

export const useShowJanePayOnKiosk = (): boolean => {
  const { storeId, store: initialStore } =
    useTypedRouteLoaderData<RootLoaderType>('root');
  const { data: store } = useGetStore<Store>(storeId, {
    initialData: initialStore,
  });
  const hideJanePay = useFlag(FLAGS.c3HideJanePayOnKiosk, false);

  return (
    !!store?.kiosk_allow_auth &&
    !!store?.jane_pay_integration?.enabled &&
    !hideJanePay
  );
};
